import { getCurrentLangKey, getBrowserLanguage } from 'ptz-i18n'

export default function getLangKey(site, location) {
  const { langs, defaultLangKey } = site.siteMetadata.languages
  const url = location.pathname
  const defaultLang = getBrowserLanguage()
    ? getBrowserLanguage().toLowerCase()
    : defaultLangKey

  return getCurrentLangKey(langs, defaultLang, url)
}
